import axios from 'axios';
// import env from 'env';
import Qs from 'qs';
import * as cookie from 'app/utils/cookie';

export const dkAdmin = axios.create({
    baseURL: process.env.REACT_APP_DK_ADMIN_SERVER,
    responseType: 'json',
    timeout: 30000,
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    }
});

// dkAdmin.interceptors.request.use((config)=> {
//   let accessToken = cookie.get(cookie.KEY_LOGIN_TOKEN);
//   config.headers = { Authorization: `Bearer ${accessToken}`};
//   return config;
// });

export const dkAdminMock = axios.create({
    responseType: 'json',
    timeout: 30000,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    }
});


export const login = (credentials) => dkAdmin.post('dk/admin/login', credentials);
export const logout = () => dkAdmin.post('dk/admin/logout');
export const forgetPassword = (request) => dkAdmin.post('dk/admin/password/reset/initiate', request);
export const changePassword = (request) => dkAdmin.put('dk/admin/password', request);
export const resetPassword = (request) => dkAdmin.post('dk/admin//password/reset/confirm', request);
export const profile = () => dkAdmin.get('dk/admin/profile');
export const skills = () => dkAdmin.get('dk/admin/skills');
export const assessments = () => dkAdmin.get('assessments');
export const candidates = (query) => dkAdmin.get(`dk/admin/report/students?${query}`);
export const report = (studentId, query) => dkAdmin.get(`dk/admin/report/student/${studentId}/details?${query}`);
export const academy = (request) => dkAdmin.post('dk/admin/academy', request);
export const company = (request) => dkAdmin.post('dk/admin/company', request);
export const ats = (request) => dkAdmin.post('dk/admin/ats', request);
export const entitiesCount = (params) => dkAdmin.get(`dk/admin/accounts/count`, {params});
export const recentEntities = () => dkAdmin.get(`dk/admin/entities/recent`);
export const getCandidateProfile = (candidateId) => dkAdmin.get(`candidates/${candidateId}/profile`);



// WEBPACK FOOTER //
// ./src/app/client/api.js